import { LATLONG_URL } from '../../Rvsf/API/api';
import { getAccessToken } from './latlongAuth';

function locationService(vehicleCategories = []) {
  async function fetchLocationSuggestions(string) {
    const api = `/api/LatLongAutoComplete?query=${string}`;
    const response = await fetch(api);
    const data = await response.json();
    return data;
  }

  async function fetchDealerInformation(pincode, vehicleCategory) {
    const selectedCategory = vehicleCategories.find((cat) => cat.displayName === vehicleCategory);
    const brandId = selectedCategory?.fields?.BrandId?.value;
    const distanceWithin = vehicleCategory === '2 Wheeler' ? '&distance_within=20' : '';
    const accessToken = await getAccessToken(brandId, selectedCategory?.displayName);
    const api = `${LATLONG_URL}/v2/brands/${brandId}/find.json?query=${pincode}${distanceWithin}&access_token=${accessToken}`;
    const response = await fetch(api);
    const data = await response.json();
    return data;
  }

  async function getLocationDetailsUsingGeo(string) {
    const api = `/api/LatLongLocation?location=${string}`;
    const response = await fetch(api);
    const data = await response.json();
    return data;
  }

  return {
    fetchLocationSuggestions,
    fetchDealerInformation,
    getLocationDetailsUsingGeo,
  };
}

export default locationService;
